import React from 'react';
import { render } from 'react-dom';
import Carousel from '../../components/Carousel';
import { fetchCarouselSlides } from '../../utilities/carousel';
import { canAutoplay } from '../../components/Carousel/canAutoPlay';

export const initCarousels = () => {
  try {
    const allCarousels = document.querySelectorAll('[data-carousel]');

    allCarousels.forEach(async (carouselRoot) => {
      const slidesEndpoint = carouselRoot.dataset.carouselSlides;
      const slides = await fetchCarouselSlides(slidesEndpoint);

      render(<Carousel slides={slides} autoplay={canAutoplay()} />, carouselRoot);
    });
  } catch (e) {
    console.error(e);
  }
};
